// extracted by mini-css-extract-plugin
module.exports = {"mrXs":"FuturesTradeRow_mrXs_3tV-C","selfCentered":"FuturesTradeRow_selfCentered_1qtiD","mAuto":"FuturesTradeRow_mAuto_37s7-"};